<template>
  <div>
    <el-card>
      <el-table :data="recipeOrderInfoList" border>
        <el-table-column prop="drugName" label="药品名称"></el-table-column>
        <el-table-column prop="amount" label="数量"></el-table-column>
        <el-table-column prop="admission" label="用法"></el-table-column>
        <el-table-column
          prop="dosage"
          label="每次剂量"
        ></el-table-column>
        <el-table-column
          prop="drugSpecification"
          label="规格"
        ></el-table-column>
        <el-table-column
          prop="frequencyName"
          label="使用频次"
        ></el-table-column>
        <el-table-column prop="drugOrigin" label="产地"></el-table-column>
        <el-table-column
          prop="drugTotalPrice"
          label="总价"
          :formatter="Price"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      recipeOrderInfoList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    Price(row) {
        return row.drugTotalPrice/100;
    },
    async init() {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: that.$route.query.id,
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http("smarthos.recipe.order.detail.info", options);
      if (res.code == 0) {
        that.recipeOrderInfoList = res.obj.recipeOrderInfoList;
      }
    },
  },
};
</script>
<style>
</style>